


// import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import storage from "redux-persist/lib/storage";
// import { persistReducer } from "redux-persist";
// import loadingReducer from "ReduxReducers/loadingReducer";
// import tokenGenerateTime from "ReduxReducers/tokenGenerateTime";
// import tokenReducer from "ReduxReducers/tokenReducer";
// import loginReducers from "ReduxReducers/loginReducers";
// import countryStateReducer from "ReduxReducers/countryStateReducer";
// import currencyReducer from "ReduxReducers/currencyReducer";
// import menuReducer from "ReduxReducers/menuReducer"
// import notificationsReducer from "ReduxReducers/notificationReducer";


// const reducers = combineReducers({
//   loader: loadingReducer,
//   notifications: notificationsReducer,
//   login: loginReducers,
//   idle: tokenGenerateTime,
//   token: tokenReducer,
//   menu: menuReducer,
//   countryState: countryStateReducer,
//   currency: currencyReducer
// });


// const persistConfig = {
//   key: "root",
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, reducers);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
//   devTools: true,
// });


import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import loadingReducer from "ReduxReducers/loadingReducer";
import tokenGenerateTime from "ReduxReducers/tokenGenerateTime";
import tokenReducer from "ReduxReducers/tokenReducer";
import loginReducers from "ReduxReducers/loginReducers";
import countryStateReducer from "ReduxReducers/countryStateReducer";
import currencyReducer from "ReduxReducers/currencyReducer";
import menuReducer from "ReduxReducers/menuReducer";
import notificationsReducer from "ReduxReducers/notificationReducer";

const reducers = combineReducers({
  loader: loadingReducer,
  notifications: notificationsReducer,
  login: loginReducers,
  idle: tokenGenerateTime,
  token: tokenReducer,
  menu: menuReducer,
  countryState: countryStateReducer,
  currency: currencyReducer,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["menu"],   // 👈 sidebar/menu persist nahi hoga
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,   // 👈 Date warnings fix
    }),
  devTools: true,
});
